import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitRoot } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IAppStore } from '../../common/state';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils/applicationContext';
import { NewbuildingBrokerModalsProvider } from '../NewbuildingBrokerModalsProvider';
import { SaveSearchModalProvider } from '../SaveSearchModalProvider';
import { SearchEngineResultsPageContainer } from '../SearchEngineResultsPageContainer';
import { SubscriptionsContainer } from '../Subscriptions';
import { ActionsCentersLoadable } from './internal/components/ActionsCenters/ActionsCentersLoadable';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IAppStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const { logger, microfrontendsRegistry } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <Provider store={reduxStore}>
          <UiKitRoot deviceType="desktop" useStaticDeviceType>
            <MicrofrontendProvider registry={microfrontendsRegistry}>
              <NewbuildingBrokerModalsProvider>
                <ActionsCentersLoadable />
                <SaveSearchModalProvider>
                  <SearchEngineResultsPageContainer />
                  <SubscriptionsContainer reduxStore={reduxStore} />
                </SaveSearchModalProvider>
              </NewbuildingBrokerModalsProvider>
            </MicrofrontendProvider>
          </UiKitRoot>
        </Provider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
